import React from "react";

import Edit from "./Edit";
import Overview from "./Overview";
export const Terms = () => {
  return (
    
      <Overview />
    
  );
};

export const EditTerms = () => {
  return (
    
      <Edit />
    
  );
};
